import { Button } from "@progress/kendo-react-buttons";
import * as styles from "./ConfirmModal.css.ts";

interface ConfirmModalProps {
  handleClose: () => void;
  handleConfirm: () => void;
}

const ConfirmModal = ({ handleClose, handleConfirm }: ConfirmModalProps) => {
  return (
    <div className={styles.buttonContainer}>
      <Button
        className={styles.modalButton}
        themeColor="secondary"
        fillMode="outline"
        onClick={handleClose}
      >
        Cancel
      </Button>
      <Button
        className={styles.modalButton}
        themeColor="primary"
        onClick={handleConfirm}
      >
        Confirm
      </Button>
    </div>
  );
};

export default ConfirmModal;
